module.exports = __webpack_public_path__ + "assets/img/cgdl.59ccee57.png";